module.exports = __webpack_public_path__ + "img/register.6f53cf8f.png";